import { gql } from '@apollo/client'

export default gql`
  query  getStore{
    assetSearchString @client{
        name
    }
  }
`
